import { useEffect, useState } from 'react';

/**
 * Ein CSS-Medienausdruck als React-Zustand.
 *
 * Warum überhaupt in JavaScript, wenn Tailwind das in CSS kann: für *Struktur*.
 * Ob ein Knopf in der Kopfzeile oder auf der Seite steht, ist kein Fall für
 * `hidden lg:flex` – dann stünde er zweimal im Baum, mit zwei Zuständen und
 * zwei Vorleseansagen. Für alles, was nur anders *aussieht*, bleiben die
 * Tailwind-Präfixe die richtige Wahl.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia(query).matches,
  );

  useEffect(() => {
    const media = window.matchMedia(query);
    const update = () => setMatches(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, [query]);

  return matches;
}

/** Dieselbe Schwelle wie Tailwinds `lg` – ab hier steht die Seitenleiste. */
export const WIDE_QUERY = '(min-width: 64rem)';

export function useIsWide(): boolean {
  return useMediaQuery(WIDE_QUERY);
}

/**
 * Unter Tailwinds `sm` – ein Telefon, im Hochformat gehalten.
 *
 * Die Grenze liegt eine Hundertstel-Einheit *unter* 40rem, damit sie sich mit
 * `sm:` nicht überschneidet: bei genau 640px gilt `sm`, und dann darf `narrow`
 * nicht auch noch wahr sein.
 */
export const NARROW_QUERY = '(max-width: 39.99rem)';

export function useIsNarrow(): boolean {
  return useMediaQuery(NARROW_QUERY);
}
